import React, { Component } from "react";
import { Row, Button, InputGroup, Col, Label } from "reactstrap";
import InputFiltro from "../../../comum/components/InputFiltro";
import Card from "../../../comum/components/Card";
import { observer, inject } from "mobx-react";
import CalendarioPicker from "../../../comum/components/Calendario";

@inject("store")
@observer
export default class FiltroConsultaEdiNf extends Component {
  filtros = {};
  constructor(props) {
    super(props);
    this.filtros = this.props.filtros;
    this.changeFiltro = this.changeFiltro.bind(this);
  }

  changeFiltro(dado, valor) {
    _.set(this.filtros, dado, valor);
  }

  render() {
    return (
      <div className="filtro-card filtros-cabotagem">
        <Card className={`area-form pb-0`}>
          <Row className="pb-0">
            <InputFiltro
              titulo="Número da nota"
              xl={2}
              md={3}
              onChange={e => this.changeFiltro("numeroNota", e.target.value)}
              autoFocus={true}
              type="number"
              limiteMaximo={10}
              onEnter={() => this.props.listar()}
            />
            <Col className="mb-4" lg={4}>
              <Col>
                <Label>Data recebimento</Label>
              </Col>
              <Col>
                <InputGroup>
                  <CalendarioPicker
                    onChangeInicio={valor =>
                      this.changeFiltro("dataInicial", valor)
                    }
                    onChangeFim={valor => this.changeFiltro("dataFinal", valor)}
                    dataInicial={this.filtros.dataInicial}
                    dataFinal={this.filtros.dataFinal}
                    close={true}
                  />
                </InputGroup>
              </Col>
            </Col>
            <Col className="mb-4">
              <Col>
                <Button
                  className="btn-com-bordas-primary btn-filtrar"
                  onClick={() => this.props.listar()}
                >
                  Filtrar
                </Button>
              </Col>
            </Col>
          </Row>
        </Card>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/nota-fiscal-transporte/edi/componentes/FiltroConsultaEdiNf.js